exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host ::ng-deep .gh-autocomplete-clear-icon{left:calc(100% - 30px) !important}", ""]);

// exports
